import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { EXPENSES_GET_ONE } from 'api/query-keys.ts';
import type { TExpenseRes } from 'api/swagger';

export const useGetExpense = (id: number) => {
  return useQuery<TExpenseRes>({
    queryKey: [EXPENSES_GET_ONE, id],
    queryFn: async () => {
      const { data } = await http.get<TExpenseRes>(`/v1/expenses/${id}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 20 * 1000,
    enabled: !!id,
  });
};
